import { Box, Checkbox, IconButton, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import listFeatureCardStyles from "src/components/templates/ListFeatureCard.module.css";
import { ActionButton } from "src/types/ActionButton";
import { Feature } from "src/types/Feature";
import { LOCATION } from "../constants/Constants";

interface ListFeatureCardProps {
  feature: Feature;
  id: number;
  totalSelected: number;
  handleSelect: (featureName: string) => void;
  isChecked: boolean;
  actions: ActionButton[];
}

const ListFeatureCard = ({
  feature,
  id,
  totalSelected,
  handleSelect,
  isChecked,
  actions,
}: ListFeatureCardProps) => {
  const [hoveredCardIndex, setHoveredCardIndex] = useState(-1);

  const handleCardMouseEnter = (index: number) => {
    setHoveredCardIndex(index);
  };

  const handleCardMouseLeave = () => {
    setHoveredCardIndex(-1);
  };
  return (
    <Box
      className={listFeatureCardStyles.listFeatureCardCss}
      key={`feature ${id}`}
      onMouseEnter={() => handleCardMouseEnter(id)}
      onMouseLeave={handleCardMouseLeave}
      sx={{
        backgroundColor: feature.location === LOCATION.REVIEW ? "#E5E4E2" : "",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex" }}>
          <Checkbox
            size="small"
            sx={{
              visibility:
                (hoveredCardIndex === id || totalSelected > 0) &&
                feature.location !== LOCATION.REVIEW
                  ? "visible"
                  : "hidden",
            }}
            onClick={() => {
              handleSelect(feature.name.replaceAll(" ", "_"));
            }}
            checked={isChecked}
          />
          <Tooltip
            placement="top-start"
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [45, -10],
                    },
                  },
                ],
              },
            }}
            title={feature.name}
          >
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                textWrap: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              Module : {feature?.name}
            </Typography>
          </Tooltip>
        </Box>
        <Box>
          {actions && (
            <Box>
              {actions.map((action, index) => {
                return (
                  <IconButton
                    key={`button ${index}`}
                    onClick={() => action.onButtonClick()}
                    disabled={action.isDisabled}
                  >
                    {action.icon}
                  </IconButton>
                );
              })}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ListFeatureCard;
